module rec OnlineDPR.Application.Client.Jsnlog

open Fable.Core
open Fable.Core.JsInterop

let GetLoggerWithName : ?loggerName: string -> JL.JSNLogLogger = import "JL" "jsnlog"
let GetLogger() : JL.JSNLogLogger =
    GetLoggerWithName ""

module JL =

    type [<AllowNullLiteral>] IExports =
        abstract setOptions: options: JSNLogOptions -> unit
        abstract createAjaxAppender: appenderName: string -> JSNLogAjaxAppender
        abstract createConsoleAppender: appenderName: string -> JSNLogConsoleAppender
        abstract getOffLevel: unit -> float
        abstract getTraceLevel: unit -> float
        abstract getDebugLevel: unit -> float
        abstract getInfoLevel: unit -> float
        abstract getWarnLevel: unit -> float
        abstract getErrorLevel: unit -> float
        abstract getFatalLevel: unit -> float
        abstract getAllLevel: unit -> float
        abstract Exception: ExceptionStatic

    type [<AllowNullLiteral>] JSNLogOptions =
        abstract enabled: bool option with get, set
        abstract maxMessages: float option with get, set
        abstract defaultAjaxUrl: string option with get, set
        abstract clientIP: string option with get, set
        abstract requestId: string option with get, set
        //abstract defaultBeforeSend: (XMLHttpRequest -> unit) option with get, set
        abstract serialize: (obj option -> string) option with get, set

    type [<AllowNullLiteral>] JSNLogFilterOptions =
        abstract level: float option with get, set
        abstract ipRegex: string option with get, set
        abstract userAgentRegex: string option with get, set
        abstract disallow: string option with get, set

    type [<AllowNullLiteral>] JSNLogLoggerOptions =
        inherit JSNLogFilterOptions
        abstract appenders: ResizeArray<JSNLogAppender> option with get, set
        abstract onceOnly: ResizeArray<string> option with get, set

    type [<AllowNullLiteral>] JSNLogAppenderOptions =
        inherit JSNLogFilterOptions
        abstract sendWithBufferLevel: float option with get, set
        abstract storeInBufferLevel: float option with get, set
        abstract bufferSize: float option with get, set
        abstract batchSize: float option with get, set
        abstract maxBatchSize: float option with get, set
        abstract batchTimeout: float option with get, set
        abstract sendTimeout: float option with get, set

    type [<AllowNullLiteral>] JSNLogAjaxAppenderOptions =
        inherit JSNLogAppenderOptions
        abstract url: string option with get, set
        //abstract beforeSend: (XMLHttpRequest -> obj option -> unit) option with get, set

    type [<AllowNullLiteral>] JSNLogLogger =
        abstract setOptions: options: JSNLogLoggerOptions -> JSNLogLogger
        abstract trace<'a> : logObject: 'a -> unit
        abstract debug<'a> : logObject: 'a -> unit
        abstract info<'a> : logObject: 'a -> unit
        abstract warn<'a> : logObject: 'a -> unit
        abstract error<'a> : logObject: 'a -> unit
        abstract fatal<'a> : logObject: 'a -> unit
        //abstract fatalException<'a> : logObject: 'a * e: Exception -> JSNLogLogger
        abstract log<'a> : level: float * logObject: 'a * ?e: obj option -> unit

    type [<AllowNullLiteral>] JSNLogAppender =
        abstract setOptions: options: JSNLogAppenderOptions -> JSNLogAppender
        abstract sendBatch: unit -> unit

    type [<AllowNullLiteral>] JSNLogAjaxAppender =
        inherit JSNLogAppender
        abstract setOptions: options: JSNLogAjaxAppenderOptions -> JSNLogAjaxAppender

    type [<AllowNullLiteral>] JSNLogConsoleAppender =
        inherit JSNLogAppender

    type [<AllowNullLiteral>] JSNLog =
        abstract setOptions: options: JSNLogOptions -> unit
        abstract createAjaxAppender: appenderName: string -> JSNLogAjaxAppender
        abstract createConsoleAppender: appenderName: string -> JSNLogConsoleAppender
        abstract getOffLevel: unit -> float
        abstract getTraceLevel: unit -> float
        abstract getDebugLevel: unit -> float
        abstract getInfoLevel: unit -> float
        abstract getWarnLevel: unit -> float
        abstract getErrorLevel: unit -> float
        abstract getFatalLevel: unit -> float
        abstract getAllLevel: unit -> float
        [<Emit "$0($1...)">] abstract Invoke: ?loggerName: string -> JL.JSNLogLogger

    type [<AllowNullLiteral>] Exception =
        interface end

    type [<AllowNullLiteral>] ExceptionStatic =
        [<Emit "new $0($1...)">] abstract Create: data: obj option * ?inner: obj option -> Exception
